<template>
  <div class="main-content" >
    <el-form :inline="true" class="form" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.searchKey" placeholder="请输入关键字" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="seachBtn">查询</el-button>
<!--        <el-button size="small" type="primary" @click="addOrUpdateHandle()">新增</el-button>-->
      </el-form-item>
    </el-form>
    <el-table
        :data="dataList"
        border
        :height="tableMaxHeight"
        ref="dataTable"
        v-loading="dataListLoading"
        @selection-change="selectionChangeHandle"
        style="width: 100%;">
      <el-table-column
          type="index"
          header-align="left"
          align="left"
          label="序号"
          width="60"
          :index="getRowsIndex"
      >
      </el-table-column>
      <el-table-column
              fixed="right"
              header-align="center"
              align="center"
              width="80"
              label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small"
                     v-if="scope.row.deviceType == 1"
                     @click="addOrUpdateHandle(scope.row.id, scope.row.tenderProjectCode, scope.row.bidSectionCode, scope.row.idCard, scope.row.fieldCode, scope.row.deviceCode)">
            关联专家
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
              prop="tenderProjectName"
              header-align="left"
              align="left"
              :show-overflow-tooltip="true"
              min-width="180"
              label="招标项目名称">
      </el-table-column>
      <el-table-column
          prop="tenderProjectCode"
          header-align="left"
          :show-overflow-tooltip="true"
          min-width="185"
          align="left"
          label="招标项目编码">
      </el-table-column>
      <el-table-column
              prop="bidSectionName"
              header-align="left"
              :show-overflow-tooltip="true"
              align="left"
              min-width="180"
              label="标段名称">
      </el-table-column>
      <el-table-column
          prop="bidSectionCode"
          header-align="left"
          min-width="210"
          :show-overflow-tooltip="true"
          align="left"
          label="标段编码">
      </el-table-column>
      <el-table-column
          prop="fieldName"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          width="180"
          label="场地名称">
      </el-table-column>
      <el-table-column
          prop="fieldCode"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="150"
          label="场地编码">
      </el-table-column>
      <el-table-column
          prop="deviceName"
          header-align="center"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
          label="设备名称">
      </el-table-column>
      <el-table-column
          prop="deviceTypeName"
          header-align="center"
          align="center"
          width="80"
          label="设备类型">
        <template slot-scope="scope" >
          <el-tag :type="scope.row.deviceType==1?'success':''"  size="small" :hit="false" effect="plain"  > {{scope.row.deviceTypeName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="personName"
          header-align="center"
          align="center"
          width="90"
          label="专家名称">
      </el-table-column>

    </el-table>
    <!-- <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper">
    </el-pagination> -->
    <pagination
            class="limit"
            :page-sizes="[10, 20, 50, 100]"
            :total="totalPage"
            :page.sync="pageIndex"
            :limit.sync="pageSize"
            @pagination="paginationChange">
      </pagination>    
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
  import AddOrUpdate from './cameras_config_add'
  import Pagination from '@/components/Pagination.vue';
  export default {
  props: ['mainContentViewHeight'],
  components: {
    AddOrUpdate,
    Pagination
  },
  data() {
    return {
      dataForm: {
        searchKey: ''
      },
      tableMaxHeight: document.documentElement.clientHeight - 252,
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      addOrUpdateVisible: false
    };
  },
  activated() {
    this.getDataList();
  },
    mounted() {
      const that = this;
      let resizeTag = true
      window.onresize = () => {
        if (resizeTag) { //防抖动
          that.ifmove();
          resizeTag = false
          setTimeout(() => {
            resizeTag = true
          }, 1000)
        }
      }
      that.ifmove();
    },
  methods: {

    ifmove() {
      let tableMaxHeight = document.documentElement.clientHeight - 328;
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      // this.getDataList()
    },
    getRowsIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
        },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: '/device/getPaged',
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          'searchKey': this.dataForm.searchKey
        }
      }).then(({data}) => {
        if (data) {
          this.dataList = data.rows;
          this.$refs.dataTable.doLayout();
          this.totalPage = data.total
          this.pageIndex = data.pageIndex
        } else {
          this.dataList = []
          this.totalPage = 0
          this.pageIndex = 1
        }
        this.dataListLoading = false
      })
    },
    // 新增 / 修改
    addOrUpdateHandle (id, tenderProjectCode, bidSectionCode, idCard, fieldCode, deviceCode) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, tenderProjectCode, bidSectionCode, idCard, fieldCode, deviceCode)
      })
    },
    // 删除
    deleteHandle (id) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/camerasConfig/delete'),
          method: 'post',
          data: {
            id:id
          }
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    }
  },
};
</script>
